import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { init } from "../../api/members/members";
import axios from "axios";
import Swal from "sweetalert2";

const Steps6 = ({ count, setCount }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    optionStatus: "Yes", // Default value for radio button
    danceType: [],
    musicType: [],
  });
  // const [acceptseva, setAcceptSeva] = useState("Yes"); // No longer needed, part of formData
  // const [skills, setSkills] = useState([]); // No longer needed, derived from formData

  var userMemberId = localStorage.getItem("aimsUserMemberId");

  const transformData = () => {
    const seva_info = {
      acceptseva: formData?.optionStatus || "",
      skill: [...formData.danceType, ...formData.musicType] || [],
    };

    return {
      seva_info: seva_info,
    };
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      if (type === "radio") {
        return {
          ...prevData,
          [name]: value,
        };
      } else if (type === "checkbox") {
        return {
          ...prevData,
          [name]: checked
            ? [...prevData[name], value]
            : prevData[name].filter((item) => item !== value),
        };
      }
      return prevData;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (validateForm()) {
    // console.log("Form Data:", formData);
    const formattedData = transformData();
    // console.log("Formatted Data:", formattedData); // Check the transformed data
    sendSevaDetails(formattedData);
    // }
  };

  const sendSevaDetails = (el) => {
    axios
      .post(
        `https://anoopam.com/aims/api/?action=sevadetail&memberid=${userMemberId}`,
        { ...el }
      )
      .then((res) => {
        // console.log(res?.data);
        if (res?.data?.status === "success") {
          Swal.fire({
            text: `${res?.data?.msg}`,
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/log-in");
            }
          });

          // navigate('/log-in')
          // setCount(res?.data?.step);
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.data?.message}`,
          icon: "error",
        });
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-4 p-4 border rounded-4  bg-white">
        <div className="row">
          <div className="tittle-text">
            Would you be eager to offer your seva as and when requested?{" "}
            <span className="fw-bold">
              તક ની સેવા હોય તો તમે ઝડપવા તૈયાર છો કે નહિ?
            </span>{" "}
            <div className="col-11 mt-3">
              <div className=" d-flex gap-3 flex-wrap">
                {["Yes", "No", "May be"].map((option, index) => (
                  <React.Fragment key={index}>
                    <input
                      hidden
                      type="radio"
                      name="optionStatus"
                      value={option}
                      id={`optionStatus-${index}`}
                      onChange={handleInputChange}
                      checked={formData?.optionStatus === option}
                    />
                    <label
                      htmlFor={`optionStatus-${index}`}
                      className={`btn rounded-5 button1 ${
                        formData?.optionStatus === option ? "active" : ""
                      }`}
                    >
                      {option}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
          {/* <div className="col-11 d-flex  gap-3   mt-4">
            <div className="d-flex align-items-center">
              <input type="checkbox" className="form-check-input" id="" />
              <label className="mx-2  tittle-text" htmlFor="">
                b12321123
              </label>
            </div>
          </div> */}

          <div className="col-11 mt-3">
            <label className="tittle-text" htmlFor="dance">
              Dance
            </label>
            <div className="col-11 d-flex gap-4 flex-wrap mt-2">
              {["Classical", "Flok", "Test"].map((dance, index) => (
                <div className="d-flex align-items-center" key={index}>
                  {/* Checkbox Input */}
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="danceType"
                    value={dance}
                    id={`danceType-${index}`}
                    onChange={handleInputChange}
                    checked={formData?.danceType?.includes(dance)}
                  />
                  {/* Label for Checkbox */}
                  <label
                    className={`${dance} tittle-text ms-2`}
                    htmlFor={`danceType-${index}`}
                  >
                    {dance}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="col-11 mt-3">
            <div>
              <label className="tittle-text" htmlFor="">
                Music
              </label>
            </div>
            <div className="col-11 d-flex gap-4 flex-wrap mt-2">
              {["Classical", "Rock", "Skill test"].map((music, index) => (
                <div className="d-flex align-items-center" key={index}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="musicType"
                    value={music}
                    id={`musicType-${index}`}
                    onChange={handleInputChange}
                    checked={formData?.musicType?.includes(music)}
                  />
                  <label
                    className={`${music} tittle-text ms-2`}
                    htmlFor={`musicType-${index}`}
                  >
                    {music}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 7 && (
          <button className="rounded-5 btnBlue" type="submit">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps6;
